import {
    useClientSettingStore,
    useStore,
    useStoreUI
} from '@assets/model/Store';
import { useConfig } from '@assets/model/StoreConfig';
import { useNavUtils } from '@assets/utils/NavUtils';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { Button } from 'react-bootstrap';
import { DealScore } from '../DealDetails/DealScore/DealScore';
import { Flex } from '../UI/Flex/Flex';
import { UploadDeal } from '../UploadDeal/UploadDeal';
import * as style from './Header.module.less';
import { Logo } from './Logo';

import { ExportDeal } from '../ExportDeal/ExportDeal';
import { NewDealNoPDF } from '../NewDealNoPDF/NewDealNoPDF';
import { ModalFeedback } from '../ModalFeedback/ModalFeedback';
import { ExportVarsOutput } from '../ExportVarsOutput/ExportVarsOutput';

interface IHeader {
    disableTicker?: boolean;
    showDealDbLink?: boolean;
    showScore?: boolean;
    showNewDeal?: boolean;
    showShadow?: boolean;
}

export const Header = observer((p: IHeader) => {
    const store = useStore();
    const storeUI = useStoreUI();
    const navUtils = useNavUtils();
    const q = store.query;
    const useShadow = p.showShadow ?? true;
    const cls = classNames(style.container, { [style.shadow]: useShadow });
    const config = useConfig();
    const clientName = config.clientName;
    const firmURL = store.firmInfo.logoURL;

    var showNewDeal = p.showNewDeal === true;
    const clientSettings = useClientSettingStore();
    if (clientSettings.onlyAdminsAddReports) {
        showNewDeal = false;
    }

    if (p.showNewDeal === true && store.isAdmin && store.showAdminConsole) {
        showNewDeal = true;
    }

    return (
        <Flex direction="column" className={cls} justify="center">
            <Flex style={{ paddingBottom: '5px' }}>
                <Button
                    variant="light"
                    className={style.feedbackButton}
                    style={{
                        visibility: useConfig().tally_url ? 'visible' : 'hidden'
                    }}
                    onClick={() => {
                        const uiStore = useStoreUI();
                        uiStore.modal = {
                            title: 'Feedback',
                            el: <ModalFeedback />
                        };
                    }}
                >
                    Feedback
                </Button>
                <Logo
                    onClick={() => {
                        navUtils.home();
                    }}
                />
                <div style={{ width: '30px' }}></div>
                {p.showDealDbLink && (
                    <div
                        className={style.dealDatabaseButton}
                        onClick={() => {
                            navUtils.home();
                        }}
                    >
                        <i className="bi bi-arrow-left-short" />
                        Back to Case Database
                    </div>
                )}

                <div className="flex-grow-1"></div>
                <div className={style.clientName}>
                    <img
                        height={40}
                        width={180}
                        src={firmURL}
                        style={{
                            objectFit: 'contain',
                            objectPosition: 'right'
                        }}
                    />
                </div>
            </Flex>

            <Flex
                direction="row"
                alignItems="center"
                className={style.headerRow}
                justify="between"
                style={{ gap: '10px' }}
            >
                <div className={style.title}>{storeUI.pageTitle}</div>
                {p.showScore && q && (
                    <DealScore
                        score={q.score()}
                        className={style.scorePosition}
                    />
                )}

                <div className="flex-grow-1"></div>
                {store.showAdminConsole && (
                    <Button
                        variant="light"
                        style={{ height: '45px' }}
                        onClick={() => {
                            navUtils.knowledgeBase();
                        }}
                    >
                        Knowledge Base
                    </Button>
                )}

                {/* {showNewDeal && <UploadDeal />} */}

                {showNewDeal && <NewDealNoPDF />}

                {p.showDealDbLink && storeUI.dealViewTab == 'DASHBOARD' && (
                    <ExportDeal />
                )}

                {storeUI.dealViewTab == 'OUTPUTS' && <ExportVarsOutput />}
            </Flex>
        </Flex>
    );
});
